import React, { useState } from 'react';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';
import { GetExpensesComponent } from '../../../generated/graphql';
import { useDateTimeService } from '../../../utils/hooks/dateTimeService';
import ExpensesBreakdownView from './ExpensesBreakdownView';


const ExpensesBreakdown = () => {
    const { dateTimeService } = useDateTimeService();

    const startDate = dateTimeService.getStartOfTheDayJsDate(new Date(new Date().setDate(new Date().getDate() - 7)));
    const endDate = dateTimeService.getEndOfTheDayJsDate(new Date());

    const [dateFrom, setDateFrom] = useState(startDate);
    const [dateTo, setDateTo] = useState(endDate);

    const handleDateFromChange = (date: MaterialUiPickersDate) => {
        if (date === null) {
            return;
        }

        setDateFrom(date.toJSDate());
    };

    const handleDateToChange = (date: MaterialUiPickersDate) => {
        if (date === null) {
            return;
        }

        /*
            for usage in query string
            date.toFormat('yyyyMMddHHmm')
        */

        setDateTo(date.toJSDate());
    };

    return (
        <GetExpensesComponent variables={{ from: dateFrom, to: dateTo }}>
            {({ data: { deductionAmounts, productCosts, currentVenueInventoryCounts } }) => (
                <ExpensesBreakdownView
                    dateFrom={dateFrom}
                    dateTo={dateTo}
                    handleDateFromChange={handleDateFromChange}
                    handleDateToChange={handleDateToChange}
                    deductionAmounts={deductionAmounts}
                    productCosts={productCosts}
                    currentVenueInventoryCounts={currentVenueInventoryCounts}
                />
            )}
        </GetExpensesComponent>
    );
};

export default ExpensesBreakdown;